<div class="center">
  <h1 mat-dialog-title> {{title}} </h1>
  <div class="message-center-content">{{ message }}</div>
</div>

<div mat-dialog-actions class="justify-content-center">
  <button mat-raised-button class="primary-button" [mat-dialog-close]="" cdkFocusInitial>Ok</button>
</div>
